'use client';

import { FullBleedImageHeadlineProps } from './types';
import Media from '@/components/shared/Media/Media';
import Eyebrow from '@/components/shared/Eyebrow/Eyebrow';
import RichTextHeadline from '@/components/shared/RichTextHeadline/RichTextHeadline';
import { liveUpdateAttrs } from '@/libs/contentful/utils';
import { cn } from '@/utils/styles';
import { BackgroundColor, Margins } from '@/types/constants';

const FullBleedImageHeadline = ({
  eyebrow,
  headline,
  media,
  mobileMedia,
  sectionName,
  margins,
  aspectRatio,
  mobileAspectRatio,
  sys,
}: FullBleedImageHeadlineProps) => {
  const heightClasses = `h-[494px] sm:h-[744px]`; // Used for both section and absolute image so heights always align

  return (
    <section
      className={cn(`flex`, BackgroundColor.DarkGreen, heightClasses)}
      {...(sectionName && { id: encodeURIComponent(sectionName) })}>
      <Media
        media={media}
        mobileMedia={mobileMedia}
        aspectRatio={aspectRatio}
        mobileAspectRatio={mobileAspectRatio}
        sizes={'100vw'}
        className={cn('absolute rounded-none w-full object-top', heightClasses)}
      />
      <div
        className={cn(
          `content-wrapper z-10 relative h-full flex flex-col text-center justify-end font-sans leading-[1.12]`,
          margins === Margins.NoBottom ? 'pt-8.5 sm:pt-16' : 'py-8.5 sm:py-16',
        )}>
        {eyebrow && (
          <div className={'text-fern text-label-saans'} {...liveUpdateAttrs(sys?.id, 'eyebrow')}>
            <Eyebrow eyebrowText={eyebrow} sys={sys} />
          </div>
        )}
        <div
          className={'font-semibold text-heading-md sm:text-heading-xl-fixed'}
          {...liveUpdateAttrs(sys?.id, 'headline')}>
          <RichTextHeadline headline={headline} level={'h3'} />
        </div>
      </div>
    </section>
  );
};

export default FullBleedImageHeadline;
